import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {PanelGroup, RunSpec, Section, SectionRun} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {
    OnSectionResizedFn,
    SectionRunView
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/SectionRunView';
import {PanelGroupView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelGroupView';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import bind from 'bind-decorator';

const styles = require('./SectionView.less');
const cx = classnames.bind(styles);

export enum SectionBorderSide
{
    None = 'None',
    North = 'North',
    East = 'East',
    South = 'South',
    West = 'West'
}

export interface SectionViewProps extends PanelContentProps
{
    key:any;
    isVisible:boolean;
    section:Section;
    borderSide:SectionBorderSide;
    onSectionResized:OnSectionResizedFn;
}

@observer
export class SectionView extends React.Component<SectionViewProps, any>
{
    @bind
    private _renderPanelGroup(group:PanelGroup)
    {
        return <PanelGroupView section={this.props.section} group={group}
                               onPanelResize={this.props.onPanelResize}/>;
    }

    @bind
    private _renderContent()
    {
        const {section} = this.props;
        const content = section.content;

        if( content instanceof PanelGroup )
        {
            const panelGroup = content as PanelGroup;
            return this._renderPanelGroup(panelGroup);
        }
        else if( content instanceof SectionRun )
        {
            const childRun = content as SectionRun;
            return <SectionRunView onSectionResized={this.props.onSectionResized}
                                   onPanelResize={this.props.onPanelResize}
                                   run={childRun}/>;
        }
        else
            return null;
    }

    render()
    {
        const {section, borderSide} = this.props;
        const runSpec = section.runSpec;
        const style = this._computeStyle(runSpec);
        const borderCssKey = SectionBorderSide[borderSide];

        return  <div style={style} className={cx('sectionContent', borderCssKey)}>
                    {this._renderContent()}
                </div>;
    }

    private _computeStyle(runSpec: RunSpec)
    {
        const style: any = {};
        const {isVisible} = this.props;

        if( !isVisible )
        {
            style.visibility = 'hidden';
            style.display = 'none';
        }
        else
        {
            style.visibility = 'inherit';
            style.display = 'flex';
        }


        if( runSpec.isStretch )
        {
            style.flexBasis = 0;
            style.flexGrow = 1;
            style.flexShrink = 1;
        }
        else if( runSpec.isPercent )
        {
            let percent = runSpec.value;
            if (percent > 1.0)
                percent /= 100.0;

            style.flexBasis = percent + '%';
            style.flexGrow = 1;
            style.flexShrink = 1;
        }
        else if( runSpec.isFixedPixels )
        {
            style.flexBasis = runSpec.value + 'px';
            style.flexGrow = 0;
            style.flexShrink = 0;
        }

        return style;
    }
}
